import {Checkbox as AntdCheckbox} from "antd";

const Checkbox = ({children, onChange,checked,disabled = false}) => {
    return (
        <AntdCheckbox
            checked={checked}
            onChange={onChange}
            disabled={disabled}
        >
            {children}
        </AntdCheckbox>
    );
};

export default Checkbox;
